import React, { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, Box, IconButton } from "@mui/material";
import styles from './styles.module.css';
import CancelConfirmation from "./CancelConfirmationModal";
import CloseIcon from '@mui/icons-material/Close';
import { axiosProxyInstance } from "../../utils/request";
import cogoToast from "cogo-toast";

const CancelSubscription = ({ details, open, onClose }) => {
    const [cancelOpen, setCancelOpen] = useState(false);
    const currentUserId = localStorage.getItem("LPCurrentUserId");

    const handleCloseMainModal = () => {
        onClose();
    };

    const handleCancelSubscription = async () => {
        try {
            const payload =
            {
                btn_submit: true,
                uid: currentUserId,
                listing_id: details?.ID,
                action: "cancel",
                provideruid: currentUserId
            };
            try {
                const res = await axiosProxyInstance.post('/signup/paymentsubscriptioncancel/', payload);
                if (res?.data?.success) {
                    setCancelOpen(true);
                } else {
                    cogoToast.error("Error canceling subscription:", res?.data?.data);
                }
            } catch (err) {
                console.error("Error canceling subscription:", err);
            }
        } catch (error) {
            console.error("Error canceling subscription:", error);
        }
    };


    const handleCloseCancelConfirmation = () => {
        setCancelOpen(false);
        onClose();
    };

    return (
        <>
            <Dialog
                open={open && !cancelOpen}
                onClose={handleCloseMainModal}
                className={styles.modalContainer}
                sx={{
                    "& .MuiDialog-paper": {
                        width: { xs: "90%", sm: "600px", md: "750px", lg: "830px" },
                        height: { xs: "auto", sm: "360px" },
                        maxWidth: "830px",
                        maxHeight: "701px",
                        borderRadius: "14px !important",
                        padding: { xs: "30px", sm: "40px", md: "60px 100px", lg: "70px 150px" },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        position: 'relative'
                    }
                }}
            >
                <IconButton
                    onClick={handleCloseMainModal}
                    sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        color: '#000'
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <DialogTitle className={styles.header}>
                    <Typography variant="gothamXL" className={styles.title}>Cancel Subscription?</Typography>
                </DialogTitle>
                <DialogContent className={styles.content}>
                    <Box className={styles.container}>
                        <Typography variant="gothamRegular" className={styles.headerText}>
                            By canceling, your clinic will no longer be visible to thousands of potential patients searching for care.
                            You’ll also lose your <b>exclusive discounted rate—</b>if you decide to return, standard pricing will apply.
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions className={styles.buttonContainer}>
                    <Button variant="contained" className={styles.cancelButton} onClick={handleCancelSubscription}>
                        Cancel Subscription
                    </Button>
                    <Button variant="outlined" className={styles.keepButton} onClick={handleCloseMainModal}>
                        Keep my Plan
                    </Button>
                </DialogActions>
            </Dialog>

            <CancelConfirmation open={cancelOpen} onClose={handleCloseCancelConfirmation} />
        </>
    );
};

export default CancelSubscription;
